import { Link } from 'react-router-dom'
import { Card } from '../components/ui/Card'
import { SectionLabel } from '../components/ui/SectionLabel'
import { KINDNESS_RULES, ESCALATION_STEPS } from '../lib/safetyContent'

/** The kindness code (COTC_SafetyKudos R4 / DESIGN §3.18). */
export function KindnessCodePage() {
  return (
    <div className="animate-rise px-10 py-9">
      <div className="font-mono text-[12px] uppercase tracking-label text-ink-fainter">The kindness code</div>
      <h1 className="mt-2 font-serif text-[32px] font-medium leading-tight tracking-[-.015em] text-ink">The kindness code</h1>
      <p className="mt-3 max-w-[60ch] text-[15px] leading-relaxed text-ink-muted">
        Every family agreed to this when they joined. It is short on purpose — kids should be able to read it themselves.
      </p>

      <ol className="mt-7 space-y-3">
        {KINDNESS_RULES.map((rule, i) => (
          <li key={i} className="flex gap-4">
            <span className="font-mono text-[13px] text-terra">{String(i + 1).padStart(2, '0')}</span>
            <span className="text-[14.5px] leading-relaxed text-ink">{rule}</span>
          </li>
        ))}
      </ol>

      <h2 className="mt-10 font-serif text-[22px] font-medium text-ink">What happens after a report</h2>
      <div className="mt-4 grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]">
        {ESCALATION_STEPS.map((s, i) => (
          <Card key={i} tone="panel">
            <SectionLabel>Step {i + 1}</SectionLabel>
            <div className="mt-2 text-[14px] font-medium text-ink">{s.title}</div>
            <p className="mt-1 text-[13px] leading-relaxed text-ink-muted">{s.body}</p>
          </Card>
        ))}
      </div>

      <div className="mt-8 flex items-center justify-between rounded-card border border-honey-chip bg-honey-bg px-5 py-4">
        <p className="text-[13.5px] text-honey-fg">Seen something that breaks the code?</p>
        <Link to="/report" className="text-[13px] font-medium text-honey-fg underline">Report a member</Link>
      </div>
    </div>
  )
}
